export type PropertyListingBillingMode = 'free' | 'paid'

export type PropertyListingBillingConfig = {
  mode: PropertyListingBillingMode
  packageName: string
  amount: number
  currency: 'IDR'
  durationMonths: number
}

export type PropertyAgentBillingConfig = {
  mode: PropertyListingBillingMode
  packageName: string
  amount: number
  currency: 'IDR'
  durationMonths: number
  listingLimit: number
  freeUntil: string
}

export type PropertyFeaturedBillingConfig = {
  packageName: string
  amount: number
  currency: 'IDR'
}

export const PROPERTY_LISTING_BILLING: PropertyListingBillingConfig = {
  mode: 'free',
  packageName: 'Iklan Listing Properti',
  amount: 399000,
  currency: 'IDR',
  durationMonths: 6,
}

export const PROPERTY_AGENT_BILLING: PropertyAgentBillingConfig = {
  mode: 'free',
  packageName: 'Agent Property Tahunan',
  amount: 1499000,
  currency: 'IDR',
  durationMonths: 12,
  listingLimit: 500,
  freeUntil: '2028-01-01T00:00:00.000+07:00',
}

export const PROPERTY_FEATURED_BILLING: PropertyFeaturedBillingConfig = {
  packageName: 'Featured Listing Properti',
  amount: 100000,
  currency: 'IDR',
}
